import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

declare global {
    interface Document {
        documentMode?: any;
    }
}

const redirectHttpToHttps = () => {
    if (environment.production) {
        if (window.location.protocol != 'https:') {
            window.location.replace(window.location.href.replace('http', 'https'));
        }
    }
}

redirectHttpToHttps();

var isIE = /*@cc_on!@*/false || !!document.documentMode;
if (isIE) {
    alert('Systemet stödjer inte Internet Explorer vänligen uppdatera till senare version eller använd annan läsare tex Google Chrome');
}

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.log(err));



// WEBPACK FOOTER //
// ./src/main.ts